import { APIResponse, ConfigurableAppMutationArgs, User, useUserLoginMutation } from '@alluradirect/react';

export const useAppUserLoginMutation = ({ ...args }: ConfigurableAppMutationArgs = {}) => {
  return useUserLoginMutation({
    onSuccess: ({ DATA: { USER } }: APIResponse<{ USER: User }>, variables) => {
      // The Lucee login returns the User Data Transfer Object which includes the GUEST_PROFILE / OWNER_PROFILE
      args.onSuccess && args.onSuccess(USER, variables);
    },
  });
};
